export default "__VITE_ASSET__CpRmOdD5__"